import type { AxisChartSettingsResult, UseGeneratedAxisChartProps } from './hooks/useGeneratedAxisChart.types';
import './css/generated-axis-chart.css';

type Props = Pick<AxisChartSettingsResult,
  'handleZoom' | 'has_undo' | 'has_redo' | 'hasZoomState'> & Pick<UseGeneratedAxisChartProps, 'can_undo' | 'can_redo'>;

export const GeneratedAxisZoomControls = ({ handleZoom, has_undo, has_redo, hasZoomState, can_undo, can_redo }: Props) => (
  <div className='generated-axis-zoom-controls' role='group' aria-label='Zoom history'>
    {can_undo && <button type='button' onClick={() => handleZoom(undefined, 'undo')} disabled={!has_undo}>Undo</button>}
    {can_redo && <button type='button' onClick={() => handleZoom(undefined, 'redo')} disabled={!has_redo}>Redo</button>}
    <button type='button' onClick={() => handleZoom(undefined, 'clear')} disabled={!hasZoomState}>Clear state</button>
  </div>
);
